module.exports = __webpack_public_path__ + "img/1c.71e140a9.svg";